export default [
  {
    path: 'activity',
    name: 'activity',
    component: () => import('./list/ActivityListPage.vue')
  },
  {
    path: 'history',
    name: 'history',
    component: () => import('./list/HistoryListPage.vue')
  }
]
